// extracted by mini-css-extract-plugin
module.exports = {"root":"LocalesTriggers_root__bL5dx","active":"LocalesTriggers_active__ScJEq"};